import { http } from './http';

export interface ApiUserGroup {
  id: number;
  groupName: string;
  groupDescription: string;
  groupIsDomain: boolean;
  GroupName?: string;
  GroupDescription?: string;
  GroupIsDomain?: boolean;
}

function normalizeGroup(g: any): ApiUserGroup {
  if (g.GroupName && !g.groupName) g.groupName = g.GroupName;
  if (g.GroupDescription && !g.groupDescription) g.groupDescription = g.GroupDescription;
  if (typeof g.GroupIsDomain === 'boolean' && typeof g.groupIsDomain !== 'boolean') g.groupIsDomain = g.GroupIsDomain;
  return g as ApiUserGroup;
}

export async function getUserGroups(): Promise<ApiUserGroup[]> { const data = await http<any[]>('/api/usergroup'); return Array.isArray(data)? data.map(normalizeGroup):[]; }
export async function addUserGroup(group: Omit<ApiUserGroup,'id'>): Promise<ApiUserGroup> { return normalizeGroup(await http('/api/usergroup',{method:'POST', json:group})); }
export async function updateUserGroup(id:number, group: Omit<ApiUserGroup,'id'>): Promise<void> { await http(`/api/usergroup/${id}`,{method:'PUT', json:group}); }
export async function deleteUserGroup(id:number): Promise<void> { await http(`/api/usergroup/${id}`,{method:'DELETE'}); }
